function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUvss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1540.403 322.106",
    style: {
      enableBackground: "new 0 0 1540.403 322.106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M732.102,108.572v22.064c0,5.231,1.284,8.94,7.326,8.94c6.037,0,7.329-3.709,7.329-8.94v-22.064 h14.649v24.884c0,13.612-9.58,17.795-21.978,17.795c-12.402,0-21.985-4.183-21.985-17.795v-24.884H732.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M784.594,113.884h0.162c3.38-4.983,7.489-6.677,13.202-6.677c11.118,0,15.541,7.003,15.541,17.148 v25.526h-14.657v-20.128c0-3.948,0.646-10.873-6.597-10.873c-5.959,0-7.651,4.429-7.651,9.58v21.421h-14.657v-41.308h14.657 V113.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M837.891,92.715c0,4.506-3.7,8.208-8.21,8.208c-4.508,0-8.215-3.702-8.215-8.208 c0-4.509,3.707-8.222,8.215-8.222C834.191,84.492,837.891,88.205,837.891,92.715 M837.007,149.877h-14.657v-41.309h14.657V149.877z "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "866.154,129.752 875.975,108.572 892.398,108.572 870.823,149.881 861.479,149.881  839.825,108.572 856.249,108.572  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M937.652,131.683H906.81c0,5.959,3.141,9.179,9.177,9.179c3.146,0,5.396-1.046,7.008-3.788h14.091 c-2.336,9.75-11.596,14.177-21.013,14.177c-13.692,0-23.918-7.734-23.918-21.98c0-13.776,9.42-22.068,22.869-22.068 c14.336,0,22.628,8.853,22.628,22.948V131.683z M924.042,123.229c-0.722-3.944-4.351-6.525-8.292-6.525 c-4.269,0-7.815,2.255-8.697,6.525H924.042z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M958.178,115.337h0.16c2.814-5.076,7.646-7.327,13.364-7.327h2.822v14.084 c-2.01-1.121-3.946-1.367-6.203-1.367c-8.133,0-10.143,5.401-10.143,12.486v16.669h-14.658v-41.312h14.658V115.337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1006.485,119.201c-2.251-1.209-5.391-2.01-7.889-2.01c-1.69,0-4.588,0.724-4.588,2.818 c0,2.823,4.588,3.221,6.602,3.62c6.839,1.369,11.994,4.591,11.994,12.243c0,10.869-9.901,15.38-19.483,15.38 c-5.882,0-11.68-1.692-16.671-4.754l5.315-10.225c2.978,2.091,7.978,4.185,11.592,4.185c1.856,0,4.595-0.884,4.595-3.142 c0-3.219-4.595-3.383-9.185-4.582c-4.59-1.214-9.174-3.461-9.174-10.871c0-10.149,9.174-14.655,18.195-14.655 c4.673,0,9.345,0.716,13.607,2.656L1006.485,119.201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1035.227,92.715c0,4.506-3.708,8.208-8.212,8.208c-4.509,0-8.217-3.702-8.217-8.208 c0-4.509,3.707-8.222,8.217-8.222C1031.52,84.492,1035.227,88.205,1035.227,92.715 M1034.343,149.877h-14.66v-41.309h14.66V149.877 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1059.218,149.881 1044.565,149.881 1044.565,120.653 1039.812,120.653 1039.812,108.572  1044.565,108.572 1044.565,96.176 1059.218,96.176 1059.218,108.572 1067.511,108.572 1067.511,120.653 1059.218,120.653  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1065.335,108.572 1082.247,108.572 1093.278,129.752 1104.068,108.572 1120.734,108.572  1087.638,170.496 1071.214,170.496 1085.305,144.245  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1170.714,131.12c0,11.35-8.858,20.05-20.134,20.05c-11.272,0-20.13-8.7-20.13-20.05 c0-11.352,8.859-20.05,20.13-20.05C1161.856,111.07,1170.714,119.768,1170.714,131.12 M1137.699,131.12 c0,7.087,5.718,13.129,12.881,13.129c7.169,0,12.887-6.042,12.887-13.129c0-7.171-5.718-13.127-12.887-13.127 C1143.417,117.992,1137.699,123.949,1137.699,131.12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1195.186,87.312c-1.443-0.643-3.299-1.531-4.832-1.531c-5.155,0-5.155,6.527-5.155,10.231v16.182 h9.987v6.77h-9.987v30.917h-7.243v-30.917h-3.301v-6.77h3.301V93.839c0-8.217,2.814-14.815,12.159-14.815 c1.772,0,3.46,0.321,5.071,0.961V87.312z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1233.19,129.752 1243.013,108.572 1259.436,108.572 1237.858,149.881 1228.519,149.881  1206.858,108.572 1223.282,108.572  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1277.791,92.715c0,4.506-3.704,8.208-8.219,8.208c-4.499,0-8.204-3.702-8.204-8.208 c0-4.509,3.706-8.222,8.204-8.222C1274.087,84.492,1277.791,88.205,1277.791,92.715 M1276.909,149.877h-14.664v-41.309h14.664 V149.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1315.552,122.022c-2.173-1.615-4.754-2.9-7.572-2.9c-5.634,0-10.063,4.347-10.063,10.067 c0,5.957,4.267,10.143,10.307,10.143c2.574,0,5.395-1.048,7.327-2.818v12.396c-3.222,1.615-6.768,2.34-10.307,2.34 c-12.236,0-22.469-9.101-22.469-21.576c0-13.293,10.149-22.469,23.112-22.469c3.379,0,6.764,0.802,9.664,2.411V122.022z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1339.864,149.881 1325.213,149.881 1325.213,120.653 1320.461,120.653 1320.461,108.572  1325.213,108.572 1325.213,96.176 1339.864,96.176 1339.864,108.572 1348.156,108.572 1348.156,120.653 1339.864,120.653  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1398.722,129.271c0,14.004-11.594,21.98-24.882,21.98c-13.204,0-24.875-7.891-24.875-21.98 c0-14.099,11.591-22.064,24.875-22.064C1387.127,107.207,1398.722,115.172,1398.722,129.271 M1364.423,129.271 c0,5.233,3.459,9.252,9.416,9.252c5.96,0,9.42-4.019,9.42-9.252c0-5.08-3.459-9.347-9.42-9.347 C1367.883,119.924,1364.423,124.191,1364.423,129.271"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1419.167,115.337h0.158c2.823-5.076,7.65-7.327,13.368-7.327h2.816v14.084 c-2.01-1.121-3.939-1.367-6.197-1.367c-8.129,0-10.145,5.401-10.145,12.486v16.669h-14.66v-41.312h14.66V115.337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1455.718,92.715c0,4.506-3.704,8.208-8.213,8.208c-4.506,0-8.208-3.702-8.208-8.208 c0-4.509,3.702-8.222,8.208-8.222C1452.015,84.492,1455.718,88.205,1455.718,92.715 M1454.836,149.877h-14.658v-41.309h14.658 V149.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1508.86,149.881h-14.657v-4.588h-0.158c-2.576,4.103-7.646,5.959-12.482,5.959 c-12.238,0-20.854-10.225-20.854-22.07c0-11.83,8.456-21.975,20.69-21.975c4.757,0,9.748,1.77,12.804,5.39v-4.024h14.657V149.881z  M1475.847,129.271c0,5.233,3.463,9.252,9.42,9.252c5.96,0,9.42-4.019,9.42-9.252c0-5.08-3.46-9.347-9.42-9.347 C1479.31,119.924,1475.847,124.191,1475.847,129.271"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M748.212,206.768c-2.255-1.212-5.397-2.014-7.89-2.014c-1.692,0-4.592,0.725-4.592,2.818 c0,2.823,4.592,3.223,6.603,3.625c6.841,1.367,11.997,4.588,11.997,12.243c0,10.867-9.9,15.377-19.486,15.377 c-5.878,0-11.676-1.69-16.671-4.75l5.315-10.227c2.983,2.091,7.975,4.185,11.598,4.185c1.854,0,4.591-0.888,4.591-3.142 c0-3.223-4.591-3.383-9.181-4.581c-4.59-1.214-9.177-3.467-9.177-10.876c0-10.149,9.177-14.651,18.197-14.651 c4.666,0,9.343,0.718,13.6,2.656L748.212,206.768z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "777.436,237.45 762.777,237.45 762.777,208.221 758.032,208.221 758.032,196.142  762.777,196.142 762.777,183.744 777.436,183.744 777.436,196.142 785.73,196.142 785.73,208.221 777.436,208.221  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M804.005,196.142v22.062c0,5.231,1.287,8.94,7.327,8.94c6.04,0,7.326-3.709,7.326-8.94v-22.062 h14.655v24.88c0,13.609-9.58,17.795-21.98,17.795c-12.406,0-21.984-4.187-21.984-17.795v-24.88H804.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M872.922,232.857h-0.159c-2.574,4.107-7.648,5.96-12.484,5.96 c-12.236,0-20.857-10.224-20.857-22.064c0-11.837,8.458-21.978,20.703-21.978c4.746,0,9.732,1.768,12.797,5.392v-29.548h14.655 v66.832h-14.655V232.857z M854.566,216.835c0,5.229,3.461,9.254,9.42,9.254c5.958,0,9.423-4.025,9.423-9.254 c0-5.075-3.465-9.342-9.423-9.342C858.027,207.494,854.566,211.761,854.566,216.835"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M938.382,219.248h-30.839c0,5.957,3.141,9.183,9.179,9.183c3.141,0,5.391-1.052,7.005-3.79h14.093 c-2.337,9.748-11.598,14.175-21.014,14.175c-13.691,0-23.918-7.728-23.918-21.982c0-13.773,9.42-22.068,22.868-22.068 c14.334,0,22.625,8.858,22.625,22.952V219.248z M924.77,210.795c-0.724-3.946-4.344-6.525-8.286-6.525 c-4.274,0-7.814,2.26-8.702,6.525H924.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M958.912,201.455h0.157c3.385-4.989,7.491-6.68,13.204-6.68c11.117,0,15.542,7.001,15.542,17.15 v25.526H973.16v-20.134c0-3.948,0.643-10.869-6.6-10.869c-5.962,0-7.648,4.429-7.648,9.578v21.424h-14.658v-41.308h14.658V201.455z "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1012.691,237.45 998.036,237.45 998.036,208.221 993.283,208.221 993.283,196.142  998.036,196.142 998.036,183.744 1012.691,183.744 1012.691,196.142 1020.981,196.142 1020.981,208.221 1012.691,208.221  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1052.142,206.768c-2.256-1.212-5.394-2.014-7.891-2.014c-1.693,0-4.593,0.725-4.593,2.818 c0,2.823,4.593,3.223,6.604,3.625c6.844,1.367,11.999,4.588,11.999,12.243c0,10.867-9.905,15.377-19.485,15.377 c-5.884,0-11.678-1.69-16.671-4.75l5.319-10.227c2.978,2.091,7.969,4.185,11.592,4.185c1.852,0,4.588-0.888,4.588-3.142 c0-3.223-4.588-3.383-9.179-4.581c-4.586-1.214-9.179-3.467-9.179-10.876c0-10.149,9.179-14.651,18.2-14.651 c4.668,0,9.338,0.718,13.609,2.656L1052.142,206.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1117.5,208.378c-0.888-1.848-2.741-3.297-4.834-3.297c-2.009,0-3.944,1.608-3.944,3.702 c0,3.299,4.351,4.75,8.778,6.768c4.431,2.009,8.696,4.748,8.696,10.703c0,7.174-5.958,12.478-12.969,12.478 c-5.47,0-11.031-3.135-13.042-8.454l6.201-2.811c1.533,2.811,3.381,4.825,6.841,4.825c3.062,0,5.722-2.091,5.722-5.311 c0-2.016-0.968-2.978-2.659-4.103l-7.085-3.786c-4.187-2.26-7.243-4.354-7.243-9.502c0-6.119,4.99-10.955,11.111-10.955 c4.586,0,8.288,2.503,10.306,6.606L1117.5,208.378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1169.348,218.685c0,11.348-8.855,20.054-20.128,20.054c-11.272,0-20.132-8.705-20.132-20.054 c0-11.352,8.86-20.05,20.132-20.05C1160.493,198.635,1169.348,207.333,1169.348,218.685 M1136.334,218.685 c0,7.09,5.72,13.131,12.885,13.131c7.165,0,12.883-6.04,12.883-13.131c0-7.169-5.718-13.129-12.883-13.129 C1142.054,205.556,1136.334,211.517,1136.334,218.685"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1202.844,210.472c-2.898-3.297-6.445-5.076-10.793-5.076c-7.083,0-12.56,6.285-12.56,13.213 c0,7.723,5.393,13.364,13.047,13.364c4.183,0,7.566-1.932,10.306-4.992v9.26c-3.305,1.77-6.6,2.492-10.388,2.492 c-11.111,0-20.214-8.53-20.214-19.806c0-11.676,9.024-20.291,20.615-20.291c3.387,0,7.089,0.8,9.987,2.503V210.472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1220.07,182.533c0,2.734-2.258,4.914-4.992,4.914c-2.738,0-4.991-2.18-4.991-4.914 c0-2.82,2.253-5.08,4.991-5.08C1217.812,177.453,1220.07,179.713,1220.07,182.533 M1218.702,237.447h-7.245v-37.688h7.245V237.447z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1233.834,219.817c0.078,6.436,4.427,12.475,11.354,12.475c5.554,0,8.532-2.812,11.275-7.327 l6.113,3.467c-3.54,6.527-10.142,10.3-17.471,10.3c-11.514,0-18.521-8.691-18.521-19.802c0-11.6,6.203-20.294,18.359-20.294 c12.001,0,17.633,8.858,17.633,20.046v1.136H1233.834z M1255.333,214.34c-0.889-5.641-4.591-9.424-10.39-9.424 c-5.632,0-9.821,4.027-10.705,9.424H1255.333z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1276.265,237.45 1269.02,237.45 1269.02,206.53 1265.07,206.53 1265.07,199.758  1269.02,199.758 1269.02,185.351 1276.265,185.351 1276.265,199.758 1283.35,199.758 1283.35,206.53 1276.265,206.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1280.448,199.758 1288.904,199.758 1301.625,223.676 1313.462,199.758 1321.596,199.758  1291.077,259.028 1282.863,259.028 1297.678,231.005  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1067.136,204.171c2.386-2.138,4.196-6.664,3.702-10.614c-2.878-1.15-4.198-2.956-4.198-5.999 c0-3.791,2.882-6.498,6.75-6.498c4.852,0,8.222,3.859,8.222,9.376c0,8.224-6.414,15.464-14.476,16.284V204.171z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M609.473,25.645H82.006c-34.863,0-56.683,22.06-56.683,61.86V234.6 c0,34.754,19.823,61.861,56.683,61.861h527.467c36.72,0,56.687-20.321,56.687-61.861V87.506 C666.16,49.301,644.595,25.645,609.473,25.645z M276.647,262.191L203.26,87.642v93c0,23.969-0.992,47.692-19.521,65.736 c-15.567,15.322-40.039,20.756-61.785,20.756c-21.745,0-46.212-5.434-61.78-20.756c-18.53-18.044-19.522-41.768-19.522-65.736 V75.861H89.09v98.107c0,24.221,1.727,50.66,32.864,50.66c31.138,0,32.869-26.44,32.869-50.66V75.861h96.121l44.978,113.181 l45.219-113.181h52.642l-79.574,186.33H276.647z M499.784,249.587c-14.577,12.359-34.102,17.547-52.889,17.547 c-23.474,0-46.453-7.909-65.482-21.249l20.754-39.046c12.108,10.625,26.443,19.274,43.003,19.274 c11.367,0,23.476-5.681,23.476-18.78c0-13.598-19.025-18.29-29.406-21.256c-30.394-8.646-50.414-16.551-50.414-52.635 c0-37.809,26.935-62.523,64.25-62.523c18.786,0,41.767,5.935,58.323,15.322l-19.274,37.564 c-8.899-7.413-20.263-12.358-32.128-12.358c-8.89,0-20.757,5.19-20.757,15.571c0,10.871,13.103,15.075,21.498,17.79l12.358,3.708 c25.949,7.661,45.961,20.758,45.961,50.909C519.056,217.957,514.612,236.982,499.784,249.587z M635.94,249.587 c-14.577,12.359-34.101,17.547-52.887,17.547c-23.478,0-46.459-7.909-65.487-21.249l20.756-39.046 c12.11,10.625,26.443,19.274,43.002,19.274c11.369,0,23.478-5.681,23.478-18.78c0-13.598-19.03-18.29-29.407-21.256 C545,177.43,524.98,169.525,524.98,133.441c0-37.809,26.94-62.523,64.252-62.523c18.782,0,41.77,5.935,58.319,15.322 l-19.277,37.564c-8.893-7.413-20.26-12.358-32.122-12.358c-8.894,0-20.758,5.19-20.758,15.571c0,10.871,13.099,15.075,21.503,17.79 l12.352,3.708c25.948,7.661,45.962,20.758,45.962,50.909C655.211,217.957,650.767,236.982,635.94,249.587z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUvss);
export default __webpack_public_path__ + "static/media/uvss.72f1a0e6.svg";
export { ForwardRef as ReactComponent };